import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { BrandMark } from './BrandMark';
const navLinks = [{
  href: '/',
  label: 'Home'
}, {
  href: '/blog',
  label: 'Blog'
}, {
  href: '/pricing',
  label: 'Pricing'
}, {
  href: 'mailto:hello@creditmanager.uk.com',
  label: 'Contact'
}];
export function LandingHeader({
  current
}: {
  current?: string;
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  function closeMenu() {
    setIsMenuOpen(false);
  }
  return <header className="sticky top-0 z-40 border-b border-stone-200 bg-white" data-id="element-165" data-mp="2m1kzs1m6oer4">
      <div className="mx-auto flex min-h-[5.5rem] max-w-7xl items-center justify-between gap-6 px-5 sm:px-8" data-id="element-166" data-mp="2lzic3o8i6xpk">
        <a href="/" className="rounded-lg outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-4" aria-label="Credit Manager home" onClick={closeMenu} data-id="element-167" data-mp="2utn3q9vgod65">
          <BrandMark data-id="element-168" data-mp="34scihts29hi6" />
        </a>

        <nav aria-label="Primary navigation" className="hidden flex-1 items-center justify-center gap-9 lg:flex" data-id="element-169" data-mp="34tdvw4wjug32">
          {navLinks.map(link => {
          const isCurrent = link.href === current;
          return <a key={link.href} href={link.href} aria-current={isCurrent ? 'page' : undefined} className={`font-display border-b-2 py-1 text-[13px] font-semibold uppercase tracking-[0.11em] transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2 ${isCurrent ? 'border-[#4BE4FF] text-[#4BE4FF]' : 'border-transparent text-[#3A3A3A] hover:text-[#041F60]'}`} data-id="element-170" data-mp="2qlbcay0hz8qv">
                {link.label}
              </a>;
        })}
        </nav>

        <a href="/signup" className="font-display hidden rounded-full bg-[#041F60] px-7 py-3.5 text-center text-[13px] font-bold uppercase leading-tight tracking-[0.09em] text-white transition-colors duration-150 hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2 lg:block" data-id="element-171" data-mp="3jba594htbq0t">
          New client
          <br data-id="element-172" data-mp="1xwn7ywhgu6fj" />
          registration
        </a>

        <button type="button" onClick={() => setIsMenuOpen(current => !current)} aria-expanded={isMenuOpen} aria-controls="mobile-navigation" aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'} className="grid h-11 w-11 place-items-center rounded-lg text-[#041F60] outline-none transition-colors duration-150 hover:bg-stone-100 focus:ring-2 focus:ring-[#041F60] lg:hidden" data-id="element-173" data-mp="1xygi4lraf8sa">
          {isMenuOpen ? <XIcon size={22} aria-hidden="true" data-id="element-174" data-mp="mh70m4rpyqtm" /> : <MenuIcon size={23} aria-hidden="true" data-id="element-175" data-mp="mhgonmt7enwo" />}
        </button>
      </div>

      {isMenuOpen && <nav id="mobile-navigation" aria-label="Mobile navigation" className="border-t border-stone-200 px-5 py-4 lg:hidden" data-id="element-176" data-mp="hkgizd09nn63">
          <div className="mx-auto flex max-w-7xl flex-col gap-1" data-id="element-177" data-mp="2y38wietszanv">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={closeMenu} className="font-display rounded-lg px-3 py-3 text-[13px] font-semibold uppercase tracking-[0.11em] text-[#041F60] outline-none transition-colors duration-150 hover:bg-stone-100 focus:ring-2 focus:ring-[#041F60]" data-id="element-178" data-mp="2jf4iho5p3nbf">
                {link.label}
              </a>)}
            <a href="/signup" onClick={closeMenu} className="font-display mt-2 rounded-full bg-[#041F60] px-5 py-3.5 text-center text-[13px] font-bold uppercase tracking-[0.09em] text-white outline-none transition-colors duration-150 hover:bg-[#031849] focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2" data-id="element-179" data-mp="20j62u6ttfhla">
              New client registration
            </a>
          </div>
        </nav>}
    </header>;
}